// Shared delivery zone definitions used by the map page and the quote modal.
// All polygon coordinates are [lat, lng] pairs.

// Approximate center of Zone 1 — used as the radar/dispatch origin
export const DELIVERY_CENTER: [number, number] = [47.2872, -122.2588]

export type DeliveryZone = {
  id: number
  price: string
  fee: number
  color: string
  polygons: number[][][]
}

export const DELIVERY_ZONES: DeliveryZone[] = [
  {
    id: 1,
    price: '+$40',
    fee: 40,
    color: '#b8b55c',
    polygons: [
      [
        [47.4800228, -122.1766336],
        [47.4781524, -122.0089267],
        [47.3890443, -122.0078198],
        [47.367306, -121.9823593],
        [47.2562263, -121.9790384],
        [47.2577289, -122.0786662],
        [47.3001607, -122.0803267],
        [47.2997853, -122.1766336],
      ],
    ],
  },
  {
    id: 2,
    price: '+$75',
    fee: 75,
    color: '#e18251',
    polygons: [
      [
        [47.493847, -122.2378074],
        [47.4079115, -122.2366727],
        [47.3871739, -122.2661738],
        [47.2895208, -122.2707125],
        [47.2579565, -122.2724145],
        [47.2564163, -122.2309994],
        [47.254876, -122.1589485],
        [47.2202085, -122.1209375],
        [47.1905306, -122.0812244],
        [47.1932292, -121.9246414],
        [47.3214509, -121.8803897],
        [47.3833327, -121.8565619],
        [47.4923136, -121.9030829],
        [47.5428899, -121.9921537],
        [47.5444218, -122.2014983],
        [47.5156921, -122.2151142],
      ],
    ],
  },
  {
    id: 3,
    price: '+$120',
    fee: 120,
    color: '#ba8989',
    polygons: [
      [
        [47.4822789, -122.3623624],
        [47.4836135, -122.3358118],
        [47.4868588, -122.2845333],
        [47.5375626, -122.2447504],
        [47.550597, -122.2350957],
        [47.5648126, -122.2324626],
        [47.5717709, -122.2390453],
        [47.577248, -122.2467253],
        [47.5846487, -122.2539663],
        [47.5921963, -122.2552829],
        [47.5936761, -122.2487001],
        [47.5953038, -122.2421173],
        [47.5936761, -122.2379482],
        [47.594564, -122.2271963],
        [47.5916044, -122.2258798],
        [47.5886446, -122.2250021],
        [47.5822806, -122.2144696],
        [47.5790243, -122.1999875],
        [47.5824286, -122.2021817],
        [47.5899766, -122.2078868],
        [47.6013694, -122.2131853],
        [47.6054233, -122.2158751],
        [47.6084102, -122.2138182],
        [47.6072368, -122.2065401],
        [47.6110769, -122.2109702],
        [47.6149167, -122.2212546],
        [47.6104369, -122.2220457],
        [47.6084102, -122.2236279],
        [47.6139568, -122.2310643],
        [47.6143834, -122.2369185],
        [47.6163033, -122.2407158],
        [47.6238753, -122.2441966],
        [47.6247296, -122.0824945],
        [47.58675, -122.1027735],
        [47.5715504, -122.0802413],
        [47.5680032, -122.0697262],
        [47.5659762, -121.9841039],
        [47.5604013, -121.9210137],
        [47.5872566, -121.8767004],
        [47.5380958, -121.7955844],
        [47.5167954, -121.7963355],
        [47.489904, -121.7565286],
        [47.4005053, -121.7948333],
        [47.1262874, -121.7828162],
        [47.135485, -122.1703701],
        [47.1375287, -122.3220869],
        [47.2125795, -122.3258423],
        [47.2752641, -122.4217872],
        [47.2813817, -122.4125263],
        [47.2856801, -122.4078959],
        [47.2921271, -122.4117952],
        [47.2969205, -122.4261739],
        [47.2965899, -122.4349474],
        [47.2997302, -122.4454268],
        [47.3056797, -122.4456705],
        [47.3121242, -122.4361659],
        [47.3180723, -122.4390904],
        [47.3208809, -122.4334851],
        [47.3215417, -122.4098456],
        [47.3240198, -122.4000973],
        [47.3283147, -122.3901053],
        [47.326828, -122.3786511],
        [47.3327745, -122.3786511],
        [47.3367384, -122.3611041],
        [47.3410323, -122.3391705],
        [47.3479679, -122.3250355],
        [47.3611761, -122.323817],
        [47.3893973, -122.3274726],
        [47.406059, -122.3323467],
        [47.4209985, -122.350294],
        [47.4379208, -122.3522688],
        [47.4468251, -122.3632401],
        [47.4515734, -122.3814525],
        [47.4610688, -122.3674092],
        [47.4690792, -122.3702618],
        [47.4821306, -122.3628013],
      ],
    ],
  },
  {
    id: 4,
    price: '+$150',
    fee: 150,
    color: '#c98ea3',
    polygons: [
      [
        [47.4811923, -122.3817267],
        [47.4882313, -122.2885317],
        [47.4908243, -122.2852425],
        [47.5363671, -122.2507055],
        [47.5633779, -122.2419342],
        [47.5781724, -122.2666035],
        [47.6003563, -122.2660553],
        [47.6014653, -122.2644107],
        [47.6025742, -122.2167168],
        [47.6066401, -122.2216506],
        [47.6247478, -122.2578322],
        [47.6262257, -122.0758279],
        [47.5874168, -122.0999489],
        [47.5696661, -122.0725386],
        [47.5681865, -121.990856],
        [47.562638, -121.9245231],
        [47.5903747, -121.8746364],
        [47.6698051, -121.8784738],
        [47.6919796, -121.8847425],
        [47.6908566, -122.2275923],
        [47.648164, -122.2609597],
        [47.6532215, -122.4311333],
        [47.5176231, -122.4152838],
        [47.4815546, -122.3810822],
      ],
      [
        [47.3573662, -122.648859],
        [47.3562576, -122.5973119],
        [47.3558881, -122.5746748],
        [47.3296452, -122.5741293],
        [47.3377782, -122.580675],
        [47.3418442, -122.5834023],
        [47.3436923, -122.5834023],
        [47.3396264, -122.5883116],
        [47.3375933, -122.5921299],
        [47.3359299, -122.5926754],
        [47.3329725, -122.5855842],
        [47.3320482, -122.5834023],
        [47.3289058, -122.579584],
        [47.3266874, -122.5774021],
        [47.3215109, -122.5757657],
        [47.3111564, -122.56922],
        [47.3026494, -122.5626744],
        [47.2967307, -122.554765],
        [47.2897014, -122.5498558],
        [47.2858164, -122.5490375],
        [47.281931, -122.5512194],
        [47.2786005, -122.5528559],
        [47.2761951, -122.5569469],
        [47.2693481, -122.5621289],
        [47.2634256, -122.5697655],
        [47.2586131, -122.5760384],
        [47.2558365, -122.5804022],
        [47.2545407, -122.5866752],
        [47.2582429, -122.5896753],
        [47.2613896, -122.5967664],
        [47.2678016, -122.5943604],
        [47.2711328, -122.5899966],
        [47.2759441, -122.590542],
        [47.2794598, -122.5880874],
        [47.2822352, -122.591633],
        [47.2844554, -122.5946331],
        [47.2855654, -122.5998151],
        [47.2887105, -122.6041789],
        [47.2911154, -122.6058153],
        [47.2948151, -122.6082699],
        [47.2998092, -122.6134519],
        [47.2979596, -122.6172702],
        [47.2909304, -122.6099063],
        [47.2874155, -122.6069062],
        [47.2779795, -122.5989969],
        [47.275389, -122.5976332],
        [47.2724282, -122.5998151],
        [47.2711328, -122.6079972],
        [47.2702074, -122.6142701],
        [47.2713178, -122.6213612],
        [47.2746488, -122.6259978],
        [47.2763142, -122.6284524],
        [47.2770543, -122.6330889],
        [47.2779795, -122.6379982],
        [47.2792748, -122.6434529],
        [47.2816801, -122.6527259],
        [47.2839993, -122.6594174],
        [47.2854793, -122.6643267],
        [47.2862194, -122.6684177],
        [47.2876994, -122.6716905],
        [47.2875144, -122.6785089],
        [47.2841843, -122.6812363],
        [47.2802988, -122.6820545],
        [47.2791886, -122.6875092],
        [47.2825191, -122.6954186],
        [47.2865894, -122.6965095],
        [47.2899194, -122.6951459],
        [47.294729, -122.6905093],
        [47.2971337, -122.6888729],
        [47.2928792, -122.6858728],
        [47.2915843, -122.6834182],
        [47.2939891, -122.6795999],
        [47.2969487, -122.6790544],
        [47.2991683, -122.6793272],
        [47.3021276, -122.6817818],
        [47.3047168, -122.6839637],
        [47.3065662, -122.686691],
        [47.3110045, -122.6853274],
        [47.3158122, -122.6798726],
        [47.3209893, -122.6730542],
        [47.3239473, -122.6632357],
        [47.3232078, -122.6591447],
        [47.3246868, -122.6547809],
        [47.328569, -122.6545081],
        [47.3331903, -122.6539627],
        [47.3365173, -122.65669],
        [47.3394746, -122.6613266],
        [47.3444645, -122.6673268],
        [47.3474212, -122.6632357],
        [47.3498235, -122.6591447],
        [47.3520409, -122.6553264],
        [47.3572144, -122.6485079],
      ],
      [
        [47.1846715, -122.585233],
        [47.1336725, -122.4990483],
        [47.1357937, -122.3222869],
        [47.2120589, -122.3255606],
        [47.2276584, -122.3492615],
        [47.2431704, -122.3732067],
        [47.273961, -122.420766],
        [47.2676487, -122.4226822],
        [47.2686557, -122.4291956],
        [47.2659199, -122.4307839],
        [47.2620962, -122.4322279],
        [47.2604304, -122.435228],
        [47.2593198, -122.4376827],
        [47.2687591, -122.4472284],
        [47.27135, -122.4510467],
        [47.2735706, -122.4562287],
        [47.2746809, -122.4597743],
        [47.2769015, -122.46632],
        [47.2787518, -122.4712292],
        [47.2811572, -122.4764112],
        [47.2950112, -122.4971218],
        [47.3035449, -122.5076284],
        [47.3100892, -122.5214335],
        [47.3189518, -122.5479443],
        [47.2926911, -122.5288859],
        [47.2802603, -122.5309627],
        [47.2770279, -122.5334061],
        [47.2699849, -122.5385973],
        [47.2635045, -122.5457598],
        [47.2550289, -122.5518203],
        [47.2444325, -122.5639413],
        [47.2297186, -122.5644923],
        [47.2186182, -122.5731239],
        [47.2072659, -122.5813882],
        [47.1907842, -122.5853052],
        [47.180327, -122.5853052],
      ],
    ],
  },
  {
    id: 5,
    price: '+$180',
    fee: 180,
    color: '#804747',
    polygons: [
      [
        [47.6565115, -122.4327801],
        [47.653895, -122.4277859],
        [47.6494092, -122.26353],
        [47.6927554, -122.2280152],
        [47.6935337, -121.8830617],
        [47.8649522, -121.8961914],
        [47.8630646, -122.3538557],
        [47.7982166, -122.4176286],
        [47.6637939, -122.435168],
        [47.6563998, -122.432689],
      ],
      [
        [47.1875694, -122.5900098],
        [47.1338075, -122.5002979],
        [47.1358763, -122.3254358],
        [47.1296697, -122.0365331],
        [47.0727425, -122.0357728],
        [47.0742959, -122.1688201],
        [46.8449449, -122.1703407],
        [46.8511846, -122.4805309],
        [47.0204194, -122.4774898],
        [47.0188644, -122.6044549],
        [47.1265662, -122.6629958],
      ],
    ],
  },
]

// Ray-casting point-in-polygon test
export function isPointInPolygon(
  lat: number,
  lng: number,
  polygon: number[][],
): boolean {
  let inside = false
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0]
    const yi = polygon[i][1]
    const xj = polygon[j][0]
    const yj = polygon[j][1]
    const intersect =
      yi > lng !== yj > lng && lat < ((xj - xi) * (lng - yi)) / (yj - yi) + xi
    if (intersect) inside = !inside
  }
  return inside
}

export function getZoneForPosition(
  lat: number,
  lon: number,
): { zone: number; price: string; fee: number; color: string } {
  for (const zone of DELIVERY_ZONES) {
    for (const polygon of zone.polygons) {
      if (isPointInPolygon(lat, lon, polygon)) {
        return {
          zone: zone.id,
          price: zone.price,
          fee: zone.fee,
          color: zone.color,
        }
      }
    }
  }
  return { zone: 0, price: 'Custom', fee: 0, color: '#e8d49e' }
}
